import type {CreateExtArgs} from '@wix/document-manager-core'
import type {Builder} from '@wix/document-services-types'
import type {DataBuilderFactory} from '../manifestBuilders/data/DataBuilderFactory'
import type {AppStudioRepository} from '../repository/AppStudioRepository'
import {resolvePropertiesSchema} from '../widgetDescriptors'

export class ManifestDataService {
    constructor(
        private readonly dataBuilderFactory: DataBuilderFactory,
        private readonly appStudioRepository: AppStudioRepository
    ) {}

    /**
     * Gets manifest public widget descriptor properties + slots placeholders data
     * And convert it to Builder.Data
     *
     * @param widgetPageId - Widget page id, which is used to get widget descriptor and widget slots pointers
     * @param widgetRootPointer - Pointer to component with type AppWidget,
     * @returns Builder.Data - Manifest Data valid for Builder
     */
    getManifestRootData(createExtArgs: CreateExtArgs, widgetPageId: string): Builder.Data {
        const widgetDescriptor = this.appStudioRepository.getWidgetDescriptorByPageId(widgetPageId)
        const widgetApiPropertiesSchemas = widgetDescriptor?.widgetApi?.propertiesSchemas || []
        const widgetApiPropertiesResolved = resolvePropertiesSchema(createExtArgs, widgetApiPropertiesSchemas)
        const widgetApiPropertiesResolvedMap = Object.assign({}, ...widgetApiPropertiesResolved)
        const widgetAPIDefinedData = this.dataBuilderFactory.propertySchemaToBuilderData(widgetApiPropertiesResolvedMap)
        return widgetAPIDefinedData
    }
}
